import { render } from "./ProcessPDF.vue?vue&type=template&id=7a3f515d&scoped=true"
import script from "./ProcessPDF.vue?vue&type=script&lang=js"
export * from "./ProcessPDF.vue?vue&type=script&lang=js"

import "./ProcessPDF.vue?vue&type=style&index=0&id=7a3f515d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a3f515d"]])

export default __exports__